import React from 'react'
import styled from 'styled-components'
import {
  FormError,
  Input,
  InputLabel as Label,
  DeliveryAutosuggest,
} from '../../../..'
import {
  useAddressForm,
  UseCheckoutEcontAddressResults,
  UseCheckoutSpeedyAddressResults,
  UseCheckoutEvropatAddressResults,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'

const classNames = {
  city: 'col-12 col-sm-6',
  street: 'col-12 col-sm-6',
  quarter: 'col-12 col-sm-6',
}

export const GenericAddressForm = ({
  methods,
}: {
  methods:
    | UseCheckoutEcontAddressResults
    | UseCheckoutEvropatAddressResults
    | UseCheckoutSpeedyAddressResults
}) => {
  const {
    addressState,
    onInputChange,
    setModuleAddressData,
    moduleData,
    errors,
  } = useAddressForm()
  const { address } = useGlobalLabels()

  const methodNames = Object.keys(methods || {})

  const fieldsLabel = {
    city: address?.city,
    quarter: address?.quarter,
    street: address?.street,
  }

  const selectedCity = moduleData?.moduleData?.address?.city

  const selectedMap = {
    city: selectedCity,
    quarter: moduleData?.moduleData?.address?.quarter,
    street: moduleData?.moduleData?.address?.street,
  }

  const disabledMap = {
    quarter: !selectedCity,
    street: !selectedCity,
  }

  const parentsMap = {
    quarter: selectedCity?.id,
    street: selectedCity?.id,
  }

  const removeMap = {
    city: () => {
      setModuleAddressData('city', undefined)
      setModuleAddressData('street', undefined)
      setModuleAddressData('quarter', undefined)
    },
    quarter: () => {
      setModuleAddressData('quarter', undefined)
    },
    street: () => {
      setModuleAddressData('street', undefined)
    },
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange?.(e.target.name, e.target.value)
  }

  return (
    <div>
      <InputsWrapper>
        {methodNames.map((name, index) => {
          const method = methods[name]
          const label = fieldsLabel[name]

          if (!label) return null

          return (
            <div
              className={classNames[name]}
              key={`Methods__${name}${index}--${index}`}
            >
              <DeliveryAutosuggest
                getItems={method.get}
                setItem={(value: any) => setModuleAddressData(name, value)}
                label={label}
                items={method.currentResults}
                remove={removeMap[name]}
                selected={selectedMap[name]}
                disabled={disabledMap[name]}
                parent={parentsMap[name]}
              />
              <FormError errors={errors} fieldName={name} />
            </div>
          )
        })}
        <div className="col-6 col-sm-3">
          <Label htmlFor="adbook-streetNumber">
            {address?.streetNumber}
            <Input
              value={addressState?.streetNumber}
              name="streetNumber"
              id="adbook-streetNumber"
              onChange={onChange}
            />
          </Label>
        </div>
        <div className="col-6 col-sm-3">
          <Label htmlFor="adbook-postalCode">
            {address?.postalCode}
            <Input
              value={addressState?.postalCode}
              name="postalCode"
              id="adbook-postalCode"
              onChange={onChange}
            />
          </Label>
        </div>
        <div className="col-6 col-sm-3">
          <Label htmlFor="adbook-building">
            {address?.number}
            <Input
              value={addressState?.building}
              name="building"
              id="adbook-building"
              onChange={onChange}
            />
          </Label>
        </div>
        <div className="col-6 col-sm-3">
          <Label htmlFor="adbook-entrance">
            {address?.entrance}
            <Input
              value={addressState?.entrance}
              name="entrance"
              id="adbook-entrance"
              onChange={onChange}
            />
          </Label>
        </div>
        <div className="col-6 col-sm-3">
          <Label htmlFor="adbook-floor">
            {address?.floor}
            <Input
              value={addressState?.floor}
              name="floor"
              id="adbook-floor"
              onChange={onChange}
            />
          </Label>
        </div>
        <div className="col-6 col-sm-3">
          <Label htmlFor="adbook-apartment">
            {address?.apartment}
            <Input
              value={addressState?.apartment}
              name="apartment"
              id="adbook-apartment"
              onChange={onChange}
            />
          </Label>
        </div>
        <div className="col-12 py-0 my-0">
          <FormError errors={errors} fieldName="any" />
        </div>
        <div className="col-12">
          <Label htmlFor="adbook-additionalAddressInfo">
            {address?.additionalInformation}
            <Input
              value={addressState?.additionalAddressInfo}
              name="additionalAddressInfo"
              id="adbook-additionalAddressInfo"
              onChange={onChange}
            />
            <FormError errors={errors} fieldName="additionalAddressInfo" />
          </Label>
        </div>
      </InputsWrapper>
    </div>
  )
}

const InputsWrapper = styled.div.attrs({
  className: 'row',
})``
